import useBootstrapData from './useBootstrapData';

export default function useSignoutUrl(): string {
  const bootstrapData = useBootstrapData();
  const lobbyUrl = bootstrapData?.lobby_url;
  return `/oidc/logout?lobbyUrl=${lobbyUrl}`;
}
